<template>
    <div>
        <el-table :data="dataList" fit highlight-current-row>
            <el-table-column label="服务类别" prop="type" width="500"></el-table-column>
            <el-table-column prop="member" >
                <template slot="header">
                    <p>会员单位</p>
                    <p>￥2000/年</p>
                </template>
            </el-table-column>
            <el-table-column prop="director">
                <template slot="header">
                    <p>理事单位</p>
                    <p>￥5000/年</p>
                </template>
            </el-table-column>
            <el-table-column prop="chairperson" width="300">
                <template slot="header">
                    <p>轮班理事长/副理事长单位</p>
                    <p>￥30000/年</p>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                dataList: [{
                        type: '颁发江苏省物联网服务协会证书/牌匾',
                        member: '颁发会员单位证书',
                        director: '颁发理事单位牌匾',
                        chairperson: '颁发轮值理事长/副理事长单位牌匾'
                    },
                    {
                        type: '通过协会官网向社会公告会员名单',
                        member: '',
                        director: '',
                        chairperson: ''
                    },
                    {
                        type: '免费参加协会举办的沙龙、论坛',
                        member: '',
                        director: '',
                        chairperson: ''
                    },
                    {
                        type: '免费获取协会推送的产业动态、物联网资讯',
                        member: '',
                        director: '',
                        chairperson: ''
                    },
                    {
                        type: '免费获得协会智库自研的产业研究报告',
                        member: '',
                        director: '',
                        chairperson: ''
                    },
                    {
                        type: '免费通过协会官网、官微发布新产品资讯、企业动态或企业软文发布',
                        member: '限1条/年',
                        director: '限3条/年',
                        chairperson: '限5条/年'
                    },
                    {
                        type: '享受协会主办的各类展会和培训优惠',
                        member: '9.5折',
                        director: '9折',
                        chairperson: '8.5折'
                    },
                    {
                        type: '免费享受协会全网站图片广告资源（数量有限）',
                        member: '/',
                        director: '15天时长',
                        chairperson: '30天时长'
                    },
                    {
                        type: '免费提供租用协会的会议场地',
                        member: '/',
                        director: '每年1次',
                        chairperson: '每年3次'
                    },
                    {
                        type: '有权参加协会理事会并参与协会日常事务管理',
                        member: '/',
                        director: '',
                        chairperson: ''
                    },
                    {
                        type: '享受参加协会理事会并参与制定协会发展战略的权利',
                        member: '/',
                        director: '/',
                        chairperson: ''
                    },
                    {
                        type: '优先推荐1-2名智库专家，颁发江苏省物联网服务协会产业顾问荣誉证书',
                        member: '/',
                        director: '/',
                        chairperson: ''
                    },
                    {
                        type: '优先获得协会组织相关活动的冠名权',
                        member: '/',
                        director: '/',
                        chairperson: ''
                    },
                    {
                        type: '代表协会领导参加各类商界、政界活动',
                        member: '/',
                        director: '/',
                        chairperson: ''
                    },
                    {
                        type: '代表协办单位或支持单位出席协会每年举办的大型活动',
                        member: '/',
                        director: '/',
                        chairperson: ''
                    }
                ]
            }
        }
    }
</script>
<style scoped>
    p {
        line-height: 5px;
    }
</style>